import {useSelector} from 'react-redux';

const useGetRole = ()=> {
  const user = useSelector((state=> state.user));
  return user.role;
};

export {useGetRole};